import { apiGet, apiPut, apiPatch, apiPost, apiDelete } from './client';
import type { TenantSettings, TenantDomain, TeamMember, TeamInvite, AnalyticsSummary } from '@/types';

export async function getTenantSettings(): Promise<TenantSettings> {
  return apiGet<TenantSettings>('/settings');
}

export async function patchTenantSettings(
  settings: Partial<TenantSettings['settings']>
): Promise<TenantSettings> {
  return apiPut<TenantSettings>('/settings', { settings });
}

export async function getDomains(): Promise<TenantDomain[]> {
  return apiGet<TenantDomain[]>('/tenant/domains');
}

export async function addDomain(domain: string): Promise<TenantDomain> {
  return apiPost<TenantDomain>('/tenant/domains', { domain });
}

export async function verifyDomain(domainId: string): Promise<TenantDomain> {
  return apiPost<TenantDomain>(`/tenant/domains/${domainId}/verify`);
}

export async function removeDomain(domainId: string): Promise<void> {
  return apiDelete<void>(`/tenant/domains/${domainId}`);
}

export async function getTeamMembers(): Promise<TeamMember[]> {
  return apiGet<TeamMember[]>('/tenant/team');
}

export async function inviteTeamMember(invite: TeamInvite): Promise<{ invited: boolean }> {
  return apiPost<{ invited: boolean }>('/tenant/team/invite', invite);
}

export async function removeTeamMember(userId: string): Promise<void> {
  return apiDelete<void>(`/tenant/team/${userId}`);
}

export async function updateTeamMemberRole(
  userId: string,
  role: string
): Promise<TeamMember> {
  return apiPatch<TeamMember>(`/tenant/team/${userId}`, { role });
}

export async function getAnalyticsSummary(): Promise<AnalyticsSummary> {
  return apiGet<AnalyticsSummary>('/analytics/summary');
}
